import React from 'react';
import { DateFormats, FormattableDateValue } from '../../types';
import useFormatDate from '../../hooks/useFormatDate';

type Props = {
  date: FormattableDateValue;
  format: DateFormats;
  considerTimeZone?: boolean;
};

/**
 *
 * @param date
 * @param format
 * @param considerTimeZone Defaults to true
 * @constructor
 */
const Date = ({ date, format, considerTimeZone = true }: Props) => {
  const formatDate = useFormatDate(considerTimeZone);

  return <React.Fragment>{formatDate(date, format)}</React.Fragment>;
};

export default Date;
